import $ from '@/../public/common/jquery/jquery-3.4.1'
import Swiper from '@/../public/ssflex/assets/js/swiper.min'

$(document).ready(function () {
    // Header - gnb
    $(".gnb .depth1, .gnb .bg").on("mouseenter", function () {
        $(".gnb .depth2").stop().fadeIn(750);
        $(".gnb .bg").stop().slideDown(250);
    });
    $(".gnb .depth1, .gnb .bg").on("mouseleave", function () {
        $(".gnb .depth2").stop().fadeOut(250);
        $(".gnb .bg").stop().slideUp(500);
    });
    // Header - Sitemap
    $(".header .btn-sitemap").on("click", function () {
        $(".sitemap").stop().fadeIn();
    });
    $(".sitemap .page-menu strong").on("click", function () {
        if (!$(this).parent("li").hasClass("active")) {
            $(".sitemap .page-menu > li").removeClass("active");
            $(".sitemap .page-menu .depth2 ").slideUp();
            $(this).parent("li").addClass("active");
            $(this).siblings("ul").slideDown();
        } else {
            $(this).parent("li").removeClass("active");
            $(this).siblings("ul").slideUp();
        }
    });
    $(".sitemap .btn-close, .sitemap .overlay").on("click", function () {
        $(".sitemap").stop().fadeOut();
    });
    // Header - Total Search
    $(".header .btn-search").on("click", function () {
        $(".headerSearch").stop().fadeIn();
    });
    $(".search .btn-close, .search .overlay").on("click", function () {
        $(".headerSearch").stop().fadeOut();
    });
    // 메인슬라이드
    $(".main-visual .swiper-container").each(function () {
        var swiper = new Swiper($(this), {
            slidesPerView: 3,
            loop: true,
            navigation: {
                nextEl: ".main-visual .btn-next",
                prevEl: ".main-visual .btn-prev",
            },
            breakpoints: {
                1279: {
                    slidesPerView: 2,
                },
                991: {
                    slidesPerView: 2,
                },
                767: {
                    slidesPerView: 2,
                },
                575: {
                    slidesPerView: 1,
                },
            },
        });
    });
    $(".main-update .swiper-container").each(function () {
        var swiper = new Swiper($(this), {
            slidesPerView: 3,
            spaceBetween: 24,
            navigation: {
                nextEl: ".main-update .btn-next",
                prevEl: ".main-update .btn-prev",
            },
            breakpoints: {
                991: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                767: {
                    slidesPerView: 2.3,
                    spaceBetween: 16,
                },
                575: {
                    slidesPerView: 1.3,
                    spaceBetween: 16,
                },
            },
        });
    });
    $(".main-ongoing .swiper-container").each(function () {
        var swiper = new Swiper($(this), {
            slidesPerView: 4,
            spaceBetween: 24,
            navigation: {
                nextEl: ".main-ongoing .btn-next",
                prevEl: ".main-ongoing .btn-prev",
            },
            breakpoints: {
                991: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                767: {
                    slidesPerView: 2.3,
                    spaceBetween: 16,
                },
                575: {
                    slidesPerView: 1.3,
                    spaceBetween: 16,
                },
            },
        });
    });
    // 서브 페이지 탭
    $(".list-controls .tab").each(function () {
        var tabnav = new Swiper($(this), {
            slidesPerView: "auto",
            spaceBetween: 24,
            freeMode: true,
            breakpoints: {
                767: {
                    spaceBetween: 16,
                },
            },
        });
    });
    // 아코디언 리스트
    $(".type-accordion dd").hide();
    $(".type-accordion dt").on("click", function () {
        if (!$(this).parent("dl").hasClass("active")) {
            $(".type-accordion dl").removeClass("active");
            $(".type-accordion dd").slideUp(250);
            $(this).parent("dl").addClass("active");
            $(this).siblings("dd").slideDown(250);
        } else {
            $(this).parent("dl").removeClass("active");
            $(this).siblings("dd").slideUp(250);
        }
    });
    // 결제 라디오 탭메뉴
    var radioCont = $(".payment-method .method-cont");
    $(".payment-method input[type='radio']").on("click", function () {
        radioCont.hide();
        radioCont.eq($("input[type='radio']").index(this)).show();
    });
});
